import { useQuery } from '@tanstack/react-query';
import { fetchJobTypesAdmin } from '../api/jobTypesApi';

export default function useAdminJobTypes() {
    return useQuery({
        queryKey: ['adminJobTypes'],
        queryFn: fetchJobTypesAdmin,
        staleTime: 0,
    });
}
